import { lang } from '@ott/l10n';

const currencies: Record<string, string> = {
  'uk-ua': 'UAH',
  'ru-ua': 'UAH',
  'kk-kz': 'KZT',
  'ru-kz': 'KZT',
  'en-gb': 'GBP',
  'en-us': 'USD',
  'en-ie': 'EUR',
  'en-ae': 'AED',
  de: 'EUR',
  es: 'EUR',
  tr: 'TRY',
  pl: 'PLN',
  br: 'EUR',
  az: 'EUR',
  ru: 'RUB',
  'ru-us': 'USD',
};

export default currencies[lang as string];
